import pluralize from 'helpers/pluralize';
import formatDate from 'helpers/formatDate';
import formatNumber from 'helpers/formatNumber';

import { metadataProps } from '../metadataPropTypes';
import shouldRenderValue from 'helpers/shouldRenderValue';
import { Meta } from '../Metadata.style';
import TippyToolTip from 'components/base/TippyToolTip/TippyToolTip';

/**
 * This component shows meta data of a track which is grouped.
 */
function GroupTrackMetadata({
  groupChildCount,
  releaseDate,
  primaryArtist,
  showDetailedMetadata,
  displayName,
  topic,
  isrcTooltipContent,
  isCompareLegend,
  showMediumSize,
  isSmallScreen,
}) {
  return (
    <Meta
      fontSize={
        isCompareLegend
          ? isSmallScreen
            ? '12px'
            : showMediumSize
            ? '11px'
            : '13px'
          : undefined
      }
    >
      {topic === 'social'
        ? shouldRenderValue(displayName) && <span>{displayName}</span>
        : shouldRenderValue(primaryArtist) && (
            <span>{`${
              showDetailedMetadata ? 'Track ' : ''
            }by ${primaryArtist}`}</span>
          )}
      {shouldRenderValue(releaseDate) && (
        <span>{`${formatDate(releaseDate, 'day-short')}`}</span>
      )}
      {shouldRenderValue(groupChildCount) && (
        <TippyToolTip
          enabled={isrcTooltipContent}
          tooltipContent={isrcTooltipContent}
          placement="right"
          zIndex="10000"
          canBeCopied
          maxHeight="210px"
        >
          <span className="versionsSpan">
            {`${formatNumber(groupChildCount)} ${pluralize(
              'version',
              groupChildCount
            )}`}
          </span>
        </TippyToolTip>
      )}
    </Meta>
  );
}

GroupTrackMetadata.propTypes = {
  ...metadataProps,
};

export default GroupTrackMetadata;
